export const validateString = (valueType: string, required: boolean, value: string): boolean => {
  if (!required) {
    return true
  }
  if (required && !value) {
    return false
  }
  return true
}
